import RECOMMENDATIONS from "@/data/recommendations.yml";
import ContentBlock from "@/components/newsletter/blocks/ContentBlock";
import dynamicLocalization from "@/mixins/dynamic-localization";

export default {
  components: { ContentBlock },
  mixins: [dynamicLocalization],
  data() {
    return {
      RECOMMENDATIONS,
    };
  },
};
